// filters.js
// Web Components for Collection Filter and Sort (no Shadow DOM, slot for Liquid UI)
import { observeCustomElements } from './mutationObserverUtil.js'

class CollectionFilter extends HTMLElement {

  constructor () {
    super()
    this.loading = false
    this.form = null
    this.inputs = null
    this.collectionHandle = null
    this.wrapperId = null
    this.wrapper = null
    this.params = false
    this.loader = null
    this.filterBtn = null
    this.sidebar = null
    this.sidebarClose = null
  }

  connectedCallback () {
    this.initFilter();
  }

  initFilter () {
    // Listen for form changes and submissions in the light DOM
    this.form = this.querySelector('form')
    this.inputs = this.querySelectorAll('input, select, textarea')
    this.collectionHandle = this.dataset.collectionHandle
    this.wrapperId = this.dataset.wrapperId
    this.wrapper = this.closest(`#${this.wrapperId}`)
    this.params = this.dataset.params || false
    this.loader = this.wrapper.querySelector(`.loader--main`)
    this.filterBtn = this.wrapper.querySelector('.filter_button')
    this.sidebar = this.wrapper.querySelector('.collection-sidebar')
    this.sidebarClose = this.wrapper.querySelector('.sidebar_close')
    this.showLoader()
    if (this.filterBtn) {
      this.filterBtn.addEventListener('click', e => {
        e.preventDefault()
        if (this.sidebar) {
          this.sidebar.classList.add('sidebar-active')
        }
      })
    }
    if (this.sidebarClose) {
      this.sidebarClose.addEventListener('click', e => {
        e.preventDefault()
        if (this.sidebar) {
          this.sidebar.classList.remove('sidebar-active')
        }
      })
    }
    if (this.form) {
      this.inputs.forEach(input => {
        input.addEventListener('change', e => this.onFilterChange(e))
      })
      this.form.addEventListener('submit', e => {
        e.preventDefault() // Prevent default form submission
        this.onFilterChange(e)
      })
    }
  }

  updateHTML (html, selector) {
    let temp = document.createElement('div')
    temp.innerHTML = html
    let elements = temp.querySelectorAll(selector)
    if (elements) {
      document.querySelectorAll(selector).forEach((el, index) => {
        el.innerHTML = elements[index].innerHTML
      })
    }
  }

  // if loading is true, show the loader
  showLoader () {
    if (this.loader && this.loading == true) {
      this.loader.style.display = 'block'
    } else {
      this.loader.style.display = 'none'
    }
  }

  async onFilterChange (e) {
    this.loading = true
    const form = this.form || e.target.closest('form')
    let collectionHandle
    const wrapperId = this.wrapperId
    let params
    let queryString
    if (this.params) {
      collectionHandle = this.collectionHandle
      params = new URLSearchParams(new FormData(form)).toString()
      queryString = `/collections/${collectionHandle}?${params}`
    } else {
      collectionHandle = e.target.value
      queryString = collectionHandle
    }
    try {
      const res = await fetch(queryString)
      const html = await res.text()
      this.updateHTML(
        html,
        `#${wrapperId}.collection-grid .productGridContainer`
      )
      this.updateHTML(
        html,
        `#${wrapperId}.collection-grid .collection_filter_main`
      )
      this.updateHTML(html, `#${wrapperId}.collection-grid .collection_title`)
      this.updateHTML(html, `.collection-banner`)
      this.updateHTML(html, `.breadcrumbs_section`)
      // Call initFilter once after all updates
      if (this.params) {
        history.replaceState(null, null, '?' + params)
      } else {
        history.replaceState(null, null, collectionHandle)
      }
    } catch (err) {
      console.error('Error:', err)
    } finally {
      this.loading = false
    }
    this.showLoader()
  }
}

if (!customElements.get('filter-collection')) {
  customElements.define('filter-collection', CollectionFilter)
}

observeCustomElements('filter-collection', (el) => {
    el.initFilter()
})

class CollectionSort extends HTMLElement {
  constructor () {
    super()
    this.loading = false
    this.collectionHandle = null
    this.wrapperId = null
  }

  connectedCallback () {
    // Listen for select changes in the light DOM
    this.collectionHandle = this.dataset.collection
    this.wrapperId = this.dataset.wrapperId
    const select = this.querySelector('select')
    if (select) {
      select.addEventListener('change', e => this.onSortChange(e))
    }
  }

  updateHTML (html, selector) {
    let temp = document.createElement('div')
    temp.innerHTML = html
    let elements = temp.querySelectorAll(selector)
    if (elements) {
      document.querySelectorAll(selector).forEach((el, index) => {
        el.innerHTML = elements[index].innerHTML
      })
    }
  }

  async onSortChange (e) {
    this.loading = true
    const sort = e.target.value
    const collectionHandle = this.collectionHandle
    const wrapperId = this.wrapperId
    try {
      const res = await fetch(
        `/collections/${collectionHandle}?sort_by=${sort}`
      )
      const html = await res.text()
      this.updateHTML(
        html,
        `#${wrapperId}.collection-grid .productGridContainer`
      )
      history.replaceState(null, null, '?sort_by=' + sort)
    } catch (err) {
      console.error('Error:', err)
    } finally {
      this.loading = false
    }
  }
}

if (!customElements.get('sort-collection')) {
  customElements.define('sort-collection', CollectionSort)
}
